import { Component, OnInit } from '@angular/core';
import { Input } from '@angular/core';
import { MonumentDto } from '../../../dtos/monumentDto';
import { GlobalDataService } from '../../../shared-services/global-data.service';
import { OnChanges } from '@angular/core';
import { SimpleChanges } from '@angular/core';
import { Renderer2 } from '@angular/core';
import { ViewChild } from '@angular/core';
import { Output } from '@angular/core';
import { EventEmitter } from '@angular/core';

@Component({
    selector: 'app-monument-detail',
    templateUrl: './monument-detail.component.html',
    styleUrls: ['./monument-detail.component.scss']
})
export class MonumentDetailComponent implements OnInit, OnChanges {

    constructor(public globalDataService: GlobalDataService, private renderer: Renderer2) {
    }

    @ViewChild('container')
    container: any;

    @ViewChild('smallInfo')
    smallInfo: any;

    @Input()
    monument: MonumentDto;

    @Input()
    smallWindow: boolean = false;

    slider: string[] = [];

    info = false;

    @Input()
    view :any;

    @Output()
    viewChange: EventEmitter<any> = new EventEmitter<any>();

    @Input()
    guiEnabled: boolean = true;

    ngOnInit(): void {
        this.renderer.listen('window', 'click', (e: any) => {
            if (!e.target.closest('.infoFloating') && this.smallInfo && e.target !== this.smallInfo.nativeElement) {
                this.info = false;
            }
        });
        this.view = {
            images: true,
            panoramic: false,
            threeD: false
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.monument && changes.monument.currentValue !== changes.monument.previousValue) {
            this.initMonument(changes.monument.currentValue)
        }
    }

    toggleView(key: string) {
        this.view = {
            images: false,
            panoramic: false,
            threeD: false
        }
        this.view[key] = true;
        this.viewChange.emit(this.view);
    }

    private initMonument(monument: MonumentDto) {
        this.slider = [monument.centerImage];
        if (monument.slides.length > 0 && monument.slides[0] !== '') {
            this.slider = [...this.slider, ...monument.slides];
        }
        if(!monument.componentConfiguration.threeSixty){
            this.view = {
                images: true,
                panoramic: false,
                threeD: false
            }
        }
    }

}
